
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm online-sadhana-shiledar section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> मै निर्गुणी...<br><span >एक उपशास्त्रीय संगीत की श्याम ईश्वरीय स्वरों के नाम</span>
            </h2>
            <p>By</p>
            <p>Dr. Sadhana Shiledar</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">DR. SADHANA SHILEDAR <span class="small-sm">16 MAY 2020</span></h2>
                    <p>Performer of CLASSICAL KHYAL, SEMICLASSICAL MUSIC, NIRGUNI BHAJAN & MARATHI NATYA SANGEET Works
                        as an Associate Professor at Department of Music, Vasantrao Naik Government Institute of Arts
                        and Social Sciences , (Morris College) Nagpur, Maharashtra</p>
                </div>
                <div class="">
                    <h6 class="fw-bold">ACHIEVEMENTS</h6>
                    <p class="fw-bold">AWARDS:</p>
                    <ul class="list-style list-style1">
                        <li>SURAMANI award by Sur Singar Samsad, Mumbai (1994)</li>
                        <li>NATYACHARYA Kakasaheb Khadilkar Award by Balgandharva Rasik Mandal Pune</li>
                    </ul>

                    <h6 class="fw-bold mt-3">ACHIEVEMENTS</h6>
                    <ul class="list-style list-style1">
                        <li>B-High graded Artist of All India Radio</li>
                        <li>Ph.D. of Nagpur University for research on Modern Classical Music Composers in Changing
                            Scenario of Indian Classical Music</li>
                    </ul>

                    <h6 class="fw-bold mt-3">PUBLISHED WORK</h6>
                    <ul class="list-style list-style1">
                        <li>SAUNTER AT SUNSET - CD of Raga Multani, Shree and Nirguni Kabir bhajan</li>
                        <li>GUNJAN - CD of Raga BasantMukhari, Shuddhasarang, Madhuwanti, Jaitashree</li>
                        <li>KAHAT GUNEEJAN- A book of compilation of 200 classical music compositions of 41 composers
                            (bandishkars) from Vidarbha Region of Maharashtra (with CD)</li>
                    </ul>
                </div>
            </div>

            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-sadhana.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8">
                <h6 class="fw-bold">LET’S MEET THEN.</h6>
                <h6 class="fw-bold">G.H. RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES - ONLINE SESSION</h6>
                <h6 class="fw-bold">मै निर्गुणी... निर्गुणी परंपरा की सांगीतिक अनुभूति</h6>
                <p>Speaker : Dr. Sadhana Shiledar (भारतीय शास्त्रीय संगीत गायिका)</p>
                <p>डॉ. विवेक गोखले, पं. मनोहरराव कासलीकर, पं. चंद्रशेखर रेले एवं विदुषी. आरती अंकलीकर -टिकेकर इनकी शिष्य
                </p>
                <p>Date : Saterday, 16<sup>th</sup> May 2020</p>
                <p>Time : 7:30 Pm</p>
                <p>Venue : Your Home at your Mobile</p>

                <h6 class="fw-bold">NOTE - LOGIN TO YOUR FACEBOOK ACCOUNTS 10 MINS BEFORE THE SESSION</h6>
                <p>Link: <a href="https://facebook.com/sgrkf/live" target="_blank">https://facebook.com/sgrkf/live</a>
                </p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-rahuljoshi1.web"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">You can also visit</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">You can also visit</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230"
                    src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fsgrkf%2Fvideos%2F591443561498686%2F&show_text=false&width=560&t=0"
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">PHOTOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>



        </div>

    </div>
</section>
